import React from 'react';
import { Button } from '@mui/material';

import AuthService from '../../services/authService';
import Error from '../../pages/Error';

const LoginError = (): React.JSX.Element => {
    return (
        <Error
            messages={['Login Failure']}
            defaultReason='A failure occurred while attempting to login. Please try again.'
            hideBackBtn
        >
            <Button
                variant='contained'
                color='primary'
                onClick={(): void => {
                    AuthService.logout();
                }}
                data-qa='error-action-logout'
            >
                Log Out
            </Button>
        </Error>
    );
};

export default LoginError;
